import { htmlLineBreaksToNewlines } from '@realadvisor/agency-utils';

export const stripTags = (html: string): string => html.replace(/<[^>]*>/g, '');

const decodeEntities = (text: string): string =>
  text
    .replace(/&#x27;/g, "'")
    .replace(/&#x60;/g, '`')
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&');

export const htmlToPlainText = (html: string): string => {
  const withBreaks = htmlLineBreaksToNewlines(
    html
      // A <br> that is the sole content of a block (empty line) would double
      // up with the closing tag's newline below.
      .replace(/<br\s*\/?>(?=<\/(div|p|li|tr|h[1-6]|blockquote)>)/gi, ''),
  ).replace(/<\/(div|p|li|tr|h[1-6]|blockquote)>/gi, '\n');
  return decodeEntities(stripTags(withBreaks));
};
